import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import TreeView from '@mui/lab/TreeView';
// import TreeItem from '@mui/lab/TreeItem';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

const DeptTree = ({ nodes, onHandleClick }) => {
  
  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} itemId={nodes.id} label={nodes.name} >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  const onSelectedNode = (event, itemId) => {
    //console.log(event);
//    console.log(nodeId,'nodeId');
    onHandleClick(itemId);
  } 

  return (
    <SimpleTreeView
      aria-label="file system navigator"
      // defaultCollapseIcon={<ExpandMoreIcon />}
      // defaultExpandIcon={<ChevronRightIcon />}
      onItemClick={onSelectedNode}
      sx={{ height: 'calc(100vh - 200px)', flexGrow: 1, overflowY: 'auto', display: 'flex' }}
    >
      {renderTree(nodes)}
    </SimpleTreeView>
  )
}

export default DeptTree